import React, { Suspense,useContext,useMemo } from "react";
import { Helmet } from "react-helmet";
import { useLoaderData, Await } from "react-router-dom";
import "./DisplayProfilePage.scss";
import DOMPurify from "dompurify";

import noavatar from "../../assets/noavatar.png";
import Card from "../../components/cards/card/Card.jsx";
import { AuthContext } from "../../context/AuthContext.jsx";
import apiRequest from "../../lib/apiRequest.js";
import CommunicationItem from "../../components/communicationitem/CommunicationItem.jsx";
import { isLocalhost } from "../../../checkLocalhost.jsx";

import { whatsappIcon,CompanyIcon,AddressIcon,UserNameIcon,ClientTypeIcon,ColonyInterestIcon } from "../../lib/myIcons.jsx";
import usePaginatedList from "../../components/paginationlist/usePaginationList.jsx";
import ShareProfileButton from "../../components/shareprofile/ShareProfileButton.jsx";
import OverlayLoader from "../../components/spinner/OverlayLoader.jsx";
import BhoomiSlider from "../../components/basicslider/BhoomiSlider.jsx";
import CollapsibleHeader from "../../components/collapsibleheader/CollapsibleHeader.jsx";
import CancelButton from "../../components/buttons/cancelbutton/CancelButton.jsx";


const DisplayProfilePage = () => {
  const loaderData = useLoaderData();

  const data = loaderData?.profileResponse?.[0];
  // const postsdata = loaderData?.postsResponse?.data || [];
console.log("loaderData ",loaderData)

  // console.log("dsfasdfasdfasdfsadf")
  console.log("Data ",data)
  // console.log("postsdata ",postsdata)
  // console.log("isLocalhost ",isLocalhost)









  const { currentUser } = useContext(AuthContext);

  const avatarfolder=import.meta.env.VITE_AVATARIMAGE_FOLDER

  const avatarimagelocation =isLocalhost
    ?import.meta.env.VITE_AVATARIMAGES_BASEURL + data?.id + avatarfolder
    :import.meta.env.VITE_AVATARIMAGES_SH_BASEURL + data?.id + avatarfolder

  // import CancelButton from './../../components/buttons/cancelbutton/CancelButton';
  // console.log("avatar image location",avatarimagelocation)
  // console.log("data.avatar",data.avatar)



  // const buildQueryObject = () => {
  //   return {
  //     userid: currentUser ? currentUser.id : null,
  //   };
  // };


  // const filters = useMemo(() => ({
  //   userid: currentUser ? currentUser.id : null,
  // }), [currentUser]);

  const filters = useMemo(() => ({
    userid: data ? data.id : null,
  }), [data]);


  const {
    items: postsdata,
    loading,
    reloading,
    refresh,
    hasMore,
    loadMore,
  } = usePaginatedList("/posts", {
    limit: 10,
    filters,
    scrollContainerSelector: ".postlist", // use your existing scrollable container
  });




  const avatarUrl = !data?.avatar
    ? noavatar
    : data.avatar.startsWith("https") || data.avatar.startsWith("http")
    ? data.avatar
    : `${avatarimagelocation}${data.avatar}`;
      
          





  // console.log("avatarUrl",avatarUrl)

  





 if (!data) return <div>Loading profile...</div>;         

          return (
            <>
            
            <div className="profile-page">
              <Helmet>
                <meta name="description" content={data.description} />
                <meta property="og:title" content={data.companyname} />
                <meta property="og:description" content={data.description} />
                <meta property="og:image" content={avatarUrl} />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={data.companyname} />
                <meta name="twitter:description" content={data.description} />
                <meta name="twitter:image" content={avatarUrl} />
              </Helmet>
              <div className="profile-content">

                <div className="profile-container">
                  <div className="profile-row">

                    <div className="profile-image">
                      <img src={avatarUrl} alt={data.companyname} />
                    </div>

                    <div className="profile-details">
                      {data.companyname && (
                        <div className="details-row">
                            <div className="fcol">
                              <div className="myrow">
                                <CompanyIcon color="black">

                                </CompanyIcon>
                                <span>{data.companyname}</span>

                              </div>
                              <div className="myrow">
                                {/* <AddressIcon>

                                </AddressIcon> */}

                                <span>
                                  {[data.address1, data.address2, data.colonyname]
                                  .filter((part) => part && part.trim() !== "")
                                  .join(", ")}
                                </span>

                              </div>

                            </div>
                            <div className="scol phonecol">
                                  {(data.phone || data.mobile || data.email) && currentUser && (
                                    <>
                                      {data.phone && (
                                        <div className="myrow">
                                          <CommunicationItem
                                            type="phone"
                                            display={data.phone}
                                            ItemPostId={null}
                                            ItemUserId={currentUser.id}
                                          />
                                        </div>
                                      )}

                                      {data.mobile && (
                                        <div className="myrow">
                                          <CommunicationItem
                                            type="whatsapp"
                                            display={data.mobile}
                                            ItemPostId={null}
                                            ItemUserId={currentUser.id}
                                          />
                                        </div>
                                      )}

                                      {data.email && (
                                        <div className="myrow">
                                          <CommunicationItem
                                            type="email"
                                            display={data.email}
                                            ItemPostId={null}
                                            ItemUserId={currentUser.id}
                                          />
                                        </div>
                                      )}
                                    </>
                                  )}


                            </div>

                        </div>
                      )}

                      <div className="details-row">

                          <div className="fcol">
                              <div className="myrow">
                                  <UserNameIcon  size='32' color="black">
                                  </UserNameIcon>
                                  <span>{data.username}</span>

                              </div>

                          

                          </div>
                          <div className="scol">
                            <div className="myrow">
                                {/* <ClientTypeIcon color="black">
                                </ClientTypeIcon>  */}
                                <span>{data.clienttype}</span>


                            </div>

                          </div>

                      </div>

                      <div className="details-row">
                        <label>
                          <ColonyInterestIcon color="black">
                          </ColonyInterestIcon> 


                          </label>
                        <span>
                          {data.colonyinterests &&
                            JSON.parse(data.colonyinterests)
                              .map((item) => item.colonyname)
                              .join(", ")}
                        </span>
                      </div>
                    </div>

                  </div>




                  <div className="second-row profile-flex">

                      {data.description && (
                        

                    <CollapsibleHeader title="About" defaultOpen={false}>
                      <div
                        className="profile-description"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(data.description),
                        }}
                      />

                    </CollapsibleHeader>


                      )}


                  </div>


                  <div className="third-row">
                      <div className="postlist">
                        <h1>Posts</h1>
                        {postsdata.map((post) => (
                          <Card key={post.id} item={post} showCheckbox={false} />
                        ))}

                        {/* Loading indicators */}
                        {loading && <div>Loading posts...</div>}
                        {reloading && (
                          <OverlayLoader 
                            position="sticky"
                            bottom={0}
                            text="Loading more..."
                            background= "rgba(200, 200, 200, 0.7)"
                            height="150px"

                        

                          />


                        )
                        
                        }

                      </div>


                  </div>



                </div>



                <div className="advertisement-container">{/* Ads */}

                    
                    <BhoomiSlider></BhoomiSlider>
                  

                </div>

              </div>

              <div className="profile-actions" > 

                {/* {console.log("currentUser in DisplayProfilePage: ",currentUser)} */}
                <ShareProfileButton
                  userObject={{
                    id: data.id,
                    username: data.username,
                  }}
                  isLocalHost={isLocalhost}
                  className="shareButton"
                buttonText="Share Profile"
                
                >

                </ShareProfileButton>
                <CancelButton></CancelButton>


              </div>


            </div>



          </>
          );
  
};

export default DisplayProfilePage;
